<template>
    <div>
        <div class="grid-blogs-container featured-blogs-grid-skeleton" v-if="!fetchingFeaturedBlogs">
            <div class="blog-grid-left grid-blog-image image-left featured-blog-grid-skeleton-inner">
            </div>

            <div class="grid-blog-image image-right-top w-100 blog-featured-item-right featured-blog-grid-skeleton-inner">
            </div>

            <div class="grid-blog-image image-right-bottom w-100 blog-featured-item-right featured-blog-grid-skeleton-inner">
            </div>
        </div>

        <div v-else>
            <div class="slider-featured-blogs slider-featured-blogs-desktop row m-0" ref="featuredBlogs">
                <div class="grid-blogs-container blog-group" v-for="(group, groupIndex) in featuredBlogsGrouped" :key="groupIndex" v-if="group.length == 3">
                    <div class="blog-grid-left grid-blog-image image-left">
                        <a :href="route('blogs.show', group[0].slug)">
                            <img width="100%" :src="group[0].base_image.path">
                            <div class="featured-blog-info">
                                <div class="w-100">
                                    <div class="featured-blog-name" v-html="group[0].name"></div>
                                    <div>
                                        <small><span v-html="group[0].created_at_format"></span></small>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="grid-blog-image image-right-top w-100 blog-featured-item-right">
                        <a :href="route('blogs.show', group.slice(1)[0].slug)">
                            <img width="100%" :src="group.slice(1)[0].base_image.path">
                            <div class="featured-blog-info">
                                <div class="w-100">
                                    <div class="featured-blog-name" v-html="group.slice(1)[0].name"></div>
                                    <div>
                                        <small><span v-html="group.slice(1)[0].created_at_format"></span></small>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="grid-blog-image image-right-bottom w-100 blog-featured-item-right">
                        <a :href="route('blogs.show', group.slice(1)[1].slug)">
                            <img width="100%" :src="group.slice(1)[1].base_image.path">
                            <div class="featured-blog-info">
                                <div class="w-100">
                                    <div class="featured-blog-name" v-html="group.slice(1)[1].name"></div>
                                    <div>
                                        <small><span v-html="group.slice(1)[1].created_at_format"></span></small>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <div class="slider-featured-blogs slider-featured-blogs-mobile row p-2" v-if="featuredBlogs.length >= 3">
                <div class="grid-blogs-container blog-group">
                    <div class="blog-grid-left grid-blog-image image-left">
                        <a :href="route('blogs.show', featuredBlogs[0].slug)">
                            <img width="100%" :src="featuredBlogs[0].base_image.path">
                            <div class="featured-blog-info">
                                <div class="w-100">
                                    <div class="featured-blog-name" v-html="featuredBlogs[0].name"></div>
                                    <div>
                                        <small><span v-html="featuredBlogs[0].created_at_format"></span></small>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="grid-blog-image image-right-top w-100 blog-featured-item-right">
                        <a :href="route('blogs.show', featuredBlogs[1].slug)">
                            <img width="100%" :src="featuredBlogs[1].base_image.path">
                            <div class="featured-blog-info">
                                <div class="w-100">
                                    <div class="featured-blog-name" v-html="featuredBlogs[1].name"></div>
                                    <div>
                                        <small><span v-html="featuredBlogs[1].created_at_format"></span></small>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="grid-blog-image image-right-bottom w-100 blog-featured-item-right">
                        <a :href="route('blogs.show', featuredBlogs[2].slug)">
                            <img width="100%" :src="featuredBlogs[2].base_image.path">
                            <div class="featured-blog-info">
                                <div class="w-100">
                                    <div class="featured-blog-name" v-html="featuredBlogs[2].name"></div>
                                    <div>
                                        <small><span v-html="featuredBlogs[2].created_at_format"></span></small>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {  },

        mixins: [],

        props: ['blog'],

        data() {
            return {
                fetchingFeaturedBlogs: false,
                featuredBlogs: [],
            };
        },

        created() {
            this.fetchFeaturedBlogs();
        },

        computed: {
            featuredBlogsGrouped() {
                const groupSize = 3;
                const grouped = [];
        
                for (let i = 0; i < this.featuredBlogs.length; i += groupSize) {
                    grouped.push(this.featuredBlogs.slice(i, i + groupSize));
                }

                return grouped;
            },
        },

        methods: {
            slickOptions() {
                return {
                    rows: 1,
                    dots: false,
                    arrows: true,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rtl: window.FleetCart.rtl,
                };
            },

            fetchFeaturedBlogs() {
                    $.ajax({
                        url: route('blogs.featured'),
                    }).then((response) => {
                        this.fetchingFeaturedBlogs = true;
                        this.featuredBlogs = response.data;
                        this.$nextTick(() => {
                            $(this.$refs.featuredBlogs).slick(this.slickOptions());
                        });
                    }).catch((xhr) => {
                        this.$notify(xhr.responseJSON.message);
                    }).always(() => {
                    });
                },
            },
        };
</script>
